import { render, staticRenderFns } from "./ProfileAbout.vue?vue&type=template&id=1105bb7e&scoped=true&"
import script from "./ProfileAbout.vue?vue&type=script&lang=js&"
export * from "./ProfileAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1105bb7e",
  null
  
)

export default component.exports